<router-outlet />
<osf-toast></osf-toast>
<osf-full-screen-loader></osf-full-screen-loader>

@if (isMaintenanceMode()) {
  <section class="maintenance-overlay font-bold text-xl flex flex-column align-items-center justify-content-center">
    <p>{{ 'maintenance.title' | translate }}</p>
    <p>{{ 'maintenance.message' | translate }}</p>
    <p>
      {{ 'maintenance.details' | translate }}
      <a href="https://status.cos.io/" target="_blank" rel="noopener noreferrer">https://status.cos.io/</a>
    </p>
  </section>
}
